import React, { Component } from 'react';
import { Container, Grid, Typography, Box, Button } from '@material-ui/core';
import './index.css';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import { connect } from 'react-redux';

dayjs.locale('nl');
/**
 * RMA finish screen
 *
 * @version 1.0.0
 */
class FinishRMAScreen extends Component {

  /**
   * Renderer
   *
   * @return {JSX} - the to render JSX.
   * @version 1.0.0
   */
  render() {
    return (
      <React.Fragment>
        <Container>
          <Grid container justify={'center'}>
            <Grid item xs={12} md={8}>
              <Typography variant="h6" gutterBottom className="pageTitle">Retouraanmelding verwerkt</Typography>
              <Typography variant="body1" gutterBottom>
                We hebben je retouraaanmeldig verwerkt, voordat je hem naar ons stuurt moet je hier op letten:
              </Typography>
              <Typography variant="body1" gutterBottom>
                • Stuur alleen de bestelde prodcuten op, dus <strong>niet je toestel.</strong> Reparaties kan je aanmelden via onze opstuurservice
              </Typography>
              <Typography variant="body1" gutterBottom>
                • Stuur hem voor <strong>{dayjs().add(14, 'days').locale('NL-nl').format('DD MMMM YYYY')}</strong> (binnen 2 weken) naar ons op.
              </Typography>
              <Typography variant="body1" gutterBottom={200}>
                • Echt geen printer in de buurt? Schrijf dan dit nummer <strong>#{this.props.order.id}</strong> duidelijk op een blaadje en stop deze bij in de doos. <strong>Retouren met een uitgeprinte PDF worden sneller verwerkt</strong>
              </Typography>
            </Grid>
          </Grid>
          <Grid container className="sendProduct" justify={'center'}>
            <Grid item xs={12} md={8}>
              <Typography variant="h6" gutterBottom className="sendTitle">Zo verstuur je jouw product</Typography>

              <Grid container className="stepsToRetour" justify={'flex-start'}>
                <Grid item>
                  <Box className="textCircle">
                    1
                  </Box>
                </Grid>
                <Grid item xs={10} className="box-title">
                  <Typography variant="body1" gutterBottom={200} className="todoStep">Download de PDF en print hem uit</Typography>
                </Grid>

                <Grid item xs={12} xl={8} className="stepDescr" justify={'flex-start'}>
                  <Grid item xs={12} md={6}>
                    <Button className="confirmButton">PDF afdrukken</Button>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container className="stepsToRetour" justify={'flex-start'} >
                <Grid item>
                  <Box className="textCircle">
                    2
                  </Box>
                </Grid>
                <Grid item xs={10} className="box-title">
                  <Typography variant="body1" className="todoStep">Pak hem stevig in en stuur de geprintte PDF mee</Typography>
                </Grid>

                <Grid item xs={12} xl={8} className="stepDescr" justify={'flex-start'}>
                  <Typography variant="body1" gutterBottom={200}>Dit kan bijvoorbeeld in de doos waarin je de bestelling hebt ontvangen.
                    Verpak het product altijd goed zodat er geen kans op schade is tijdens verzending!
                    FixjeiPhone is niet verantwoordelijk bij beschadigingen door onvoldoende bescherming bij verzending.</Typography>
                </Grid>
              </Grid>

              <Grid container className="stepsToRetour" justify={'flex-start'} >
                <Grid item>
                  <Box className="textCircle">
                    3
                  </Box>
                </Grid>
                <Grid item xs={10} className="box-title">
                  <Typography variant="body1" gutterBottom={200} className="todoStep">Retour verzenden, via</Typography>
                </Grid>
                <Grid item xs={12} xl={8} className="stepDescr" justify={'flex-start'}>
                  <Grid container spacing={2} justify={'flex-start'} alignItems="center">
                    <Grid item xs={12} md={6}>
                      <Button className="confirmButton sendItemBtn" onClick={() => window.open('https://www.postnl.nl/versturen/postzegels/hoe-frankeren/', '_blank').focus()}>Frankeringstarieven voor NL</Button>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Button className="confirmButton sendItemBtn" onClick={() => window.open('https://www.bpost.be/nl/price-calculator-result/74/76', '_blank').focus()}>Frankeringstarieven voor BE</Button>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} justify={'flex-start'} alignItems="center">
                    <Grid item xs={12} md={6}>
                      <Box className="retourAdress">
                        <Typography variant="body1" className="adresRetour" gutterBottom={500}>Retour adres:</Typography>
                        <Typography>FixjeiPhone</Typography>
                        <Typography>Afdeling: Retouren</Typography>
                        <Typography>Virulyweg 21-A</Typography>
                        <Typography>7602RG Almelo</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container className="stepsToRetour" justify={'flex-start'} >
                <Typography>De verwerkingstijd van een retour is gemiddeld 1 tot 3 werkdagen na ontvangst.</Typography>
                <Typography>De verwerkingstijd voor terugbetalingen is gemiddeld 2 tot 5 werkdagen na ontvangst.</Typography>
                <Typography className="lastRow">Je kunt jouw retour altijd terug vinden je ‘mijn account’. <strong>We sturen je een bevestigen van je retourzending op de mail!</strong></Typography>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  order: state.orders.order,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(FinishRMAScreen);
